module.exports = __webpack_public_path__ + "static/img/fty_logo.c745b85a.png";